exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bn-input-label[data-v-61a6a7d9]{font-size:17px}.fade-enter-active[data-v-61a6a7d9],.fade-leave-active[data-v-61a6a7d9]{transition:opacity .5s}.fade-enter[data-v-61a6a7d9],.fade-leave-to[data-v-61a6a7d9]{opacity:0}@media only screen and (max-width:960px){.input-wrapper[data-v-61a6a7d9]{flex-direction:column}}.separate-label[data-v-61a6a7d9]{height:56px;display:inline-flex;align-items:center;padding-right:16px}.suffix[data-v-61a6a7d9]{margin-top:3px}", ""]);

// exports
